import { getField, updateField } from "vuex-map-fields";

import axios from 'axios';

import testProject from './../../js/testProject.js'
import {availableProjects} from './../../js/testAvailableProjects.js'

import {
  isValidSection1,
  isValidSection2a,
  isValidSection2b,
  isValidSection2c,
  isValidSection2d,
  isValidSection3,
  isValidSection4
} from "../../js/validation/projectValidation";


// const { getProjectField, updateProjectField } = createHelpers({
//   getterType: 'getProjectField',
//   mutationType: 'updateProjectField'
// });


const state = {
  folderTree: null,
  availableProjects: availableProjects,
  currentProject: testProject,
  userToShareWith: null,
  currentProjectIsValid: {
    section: {
      '1': null,
      '2': null,
      '2a': null,
      '2b': null,
      '2c': null,
      '2d': null,
      '3': null,
      '4': null,
      '5': null,
    }
  },
  currentPageValidationState: null
};

const getters = {
  getField,
  projectIsValid: function(state) {
    const isValid = state.currentProjectIsValid.section['5'];

    // Do it live if we have to.
    // const p = state.currentProject;
    // const a = isValidSection1(p);
    // const b = isValidSection2a(p);
    // const c = isValidSection2b(p);
    // const d = isValidSection2c(p);
    // const e = isValidSection2d(p);
    // const f = isValidSection3(p);
    // const g = isValidSection4(p);
    //
    // console.log("Project Validity", a, b, c, d, e, f, g);

    // const isValid = a && b && c && d && e && f && g;

    return isValid
  },
};

const actions = {

  /*
  validateProjectState is a vuex action used by the left-hand nav to validate all sections
  on load. It duplicates validation checks and should probably be integrated better with
  the vuelidate logic in the components.
   */
  validateProjectState(context){
    const p = context.state.currentProject;
    context.commit('setValidSection',{ section: '1', value:   isValidSection1(p) });
    context.commit('setValidSection',{ section: '2a', value:  isValidSection2a(p)});
    context.commit('setValidSection',{ section: '2b', value:  isValidSection2b(p)});
    context.commit('setValidSection',{ section: '2c', value:  isValidSection2c(p)});
    context.commit('setValidSection',{ section: '2d', value:  isValidSection2d(p)});
    context.commit('setValidSection',{ section: '3', value:   isValidSection3(p) });
    context.commit('setValidSection',{ section: '4', value:   isValidSection4(p) });
  },
  saveProject(context){
    const p = context.state.currentProject;
    console.log("Saving project", p.id, p.projectName);
    return context.dispatch('postToServer', {
      action: 'saveProject',
      project: p
    },{root:true}).then(result => {
      if (result.status === 'success'){
      //   context.commit('setCurrentProject', result.payload)
        context.commit('setCurrentProjectLastModified', result.payload)
        context.commit('resetPageIsDirty');
      }

      return result
    });
  },
  saveFolder(context, folderData) {
    return context.dispatch('postToServer',{
      action: 'saveFolder',
      parentId: folderData.parentId,
      folderName: folderData.folderName
    },{root:true})
  },
  deleteFolder(context, folderId){
    console.log("deleting", folderId);
    return context.dispatch('postToServer', {
      action: 'deleteFolder',
      folderId: folderId
    }, {root: true}).then(result => {
      console.log("Folder delete result", result);
      context.dispatch('getAvailableProjects');
      context.dispatch('getFolders');
    })
  },
  getFolders(context){
    return context.dispatch('postToServer',{
      action: 'getFolders',
    },{root:true}).then(result => {
      // Set tree of folder objects
      context.commit('setFolders', result.payload[0]);
    });
  },
  getAvailableProjects(context){
    return context.dispatch('postToServer',{
      action: 'getAvailableProjects',
    },{root:true}).then(result => {
      context.commit('setAvailableProjects', result.payload)
      return result
    })
  },
  getFullProject(context, id){
    return context.dispatch('postToServer', {
      action: 'getFullProject',
      id: id
    },{root:true}).then(result => {
      console.log("Full project got", result.payload);
      context.commit('setCurrentProject', result.payload)
    }).then(() => {
      context.dispatch('validateProjectState')
      return context.currentProject
    })
  },
  createNewProject(context, payload){
    return context.dispatch('postToServer',{
      action: 'createProject',
      folderId: payload.folderId
    },{root:true})
  },
  copyProject(context, id){
    return context.dispatch('postToServer',{
      action: 'copyProject',
      id: id
    }, {root:true})
  },
  deleteProject(context, projectId){
    return context.dispatch('postToServer',{
      action: 'deleteProject',
      id: projectId
    },{root:true})
  },
  shareProject(context){
    const p = JSON.parse(JSON.stringify(context.state.currentProject));

    p.id = null;
    p.folderId = null;

    p.sharedWith = context.state.userToShareWith;

    console.log("Sharing project", p.id, p.projectName);

    return context.dispatch('postToServer', {
      action: 'shareProject',
      // project: p,
      projectId: context.state.currentProject.id,
      sharedWith: context.state.userToShareWith

    },{root:true}).then(result => {
      if (result.status === 'success'){
      //   context.commit('setCurrentProject', result.payload)
        context.commit('setCurrentProjectLastModified', result.payload)
        context.commit('resetPageIsDirty');
      }

      return result
    });
  }
};

const mutations = {
  updateField,
  setAvailableProjects(state, availableProjects){
    // const currProjectIds = state.availableProjects.map(ap => { return ap.id });
    state.availableProjects = availableProjects;
  },
  setCurrentProject(state, project){
    if (project !== null){
      console.log("Current project changed to", project.id, project.projectName);
    } else {
      console.log("Current project set to", project);
    }
    state.currentProject = project
  },
  setCurrentProjectLastModified(state, dateTimeString){
    state.currentProject.lastModified = dateTimeString
  },
  setFolders(state, folderTree){
    state.folderTree = folderTree
  },
  setValidSection(state, payload){
    /*
    Vuex mutation for setting validity of various subsections of a project definition

    payload = {
      section: String,  // Section ID
      payload: Boolean, // Is Valid
    }

    */
    // console.log("Updating state of " + payload.section, payload.value);
    state.currentProjectIsValid.section[payload.section] = payload.value;

    const s = state.currentProjectIsValid.section;

    // Automatically set section 2 as valid if all subsections are valid
    // Only trigger if a subsection of 2 changes
    if (payload.section.startsWith('2')){
      s['2'] = s['2a'] && s['2b'] && s['2c'] && s['2d'];
    }

    // Section 5 is validity for the Whole Project -> It corresponds to the report component
    s['5'] = s['1'] && s['2'] && s['3'] && s['4'];
    state.currentProject.complete = s['5'];
    // if (s['5']) { console.log("Project is valid")}
  },
  resetPageIsDirty(state){
    if (state.currentPageValidationState !== null && state.currentPageValidationState !== undefined){
      console.log("Resetting page dirty status");
      try {
        state.currentPageValidationState.$reset()
      } catch (Exception){
        console.log("bypass validation reset")
      }
    }
  },
  setPageValidationState(state, vuelidateObject){
    console.log("Setting new store validator", vuelidateObject);
    state.currentPageValidationState = vuelidateObject
  },
  setPageDirty(state){
    if (state.currentPageValidationState !== null && state.currentPageValidationState !== undefined){
      console.log("Setting global page validation state to dirty");
      // state.currentPageValidationState.$touch()
    } else {
      console.log("Attempted to set form to 'dirty' but no validation object found.")
    }
  }

};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
